export const ImageReaderServiceModule = angular
    .module('app.services.utilities.imageReaderService', [])
    .factory('imageReader', ($q, $window) => {
        let getImageData = (file) => {
            let deferred = $q.defer();
            if (angular.isUndefined(file)) {
                deferred.reject('Please pass a valid file');
            }
            if (angular.isUndefined($window.FileReader)) {
                deferred.reject('Browser does not support FileReader API');
            }

            let fileReader = new $window.FileReader();

            fileReader.addEventListener('progress', (e) => {
                if (e.lengthComputable) {
                    var percentage = Math.round((e.loaded * 100) / e.total);
                    deferred.notify(percentage);
                }
            });

            fileReader.addEventListener('load', () => {
                deferred.resolve(fileReader.result);
            });

            fileReader.readAsDataURL(file);

            return deferred.promise;
        };

        let getImagesData = (files) => {
            let defer = $q.defer();
            let promises = [];

            angular.forEach(files, (file) => {
                promises.push(getImageData(file));
            });

            $q.all(promises).then((data) => {
                defer.resolve(data);
            });

            return defer.promise;
        };

        return {
            getImageData,
            getImagesData
        };
    }).name;


// WEBPACK FOOTER //
// ./src/app/services/utilities/imageReader.service.js